import { executeStandardRequest } from '@musinsa/packages-http';
import { publicHttpClient } from '../httpClient';
import { productsApiPath } from './apiPath';
import type { PopularProductsResponse } from './type';

export interface GetPopularProductsRequestParams {
  snsTitle: string;
  page?: number;
  size?: number;
}

export const getPopularProducts = async ({
  snsTitle,
  ...restParams
}: GetPopularProductsRequestParams) => {
  return executeStandardRequest(() =>
    publicHttpClient.get<PopularProductsResponse>(
      productsApiPath.getPopularProducts(snsTitle),
      restParams,
    ),
  );
};
